export default __webpack_public_path__ + "static/recreation-header-bg-5e8a2b750dd37632400f412df8262470.jpg";